import { Layout } from "@/components/Layout";
import { useSEO } from "@/hooks/use-seo";

export default function Legal() {
  useSEO({
    title: "Legal - The Lifecycle Canvas",
    description: "Legal information, terms of service, and privacy policy for The Lifecycle Canvas.",
    ogTitle: "Legal - The Lifecycle Canvas",
    noIndex: true,
  });

  return (
    <Layout>
      <section className="py-20 px-6">
        <div className="max-w-3xl mx-auto prose prose-invert prose-slate">
          <h1 className="text-4xl font-display font-bold text-white mb-8">Legal Information</h1>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">Terms of Service</h2>
            <p className="text-slate-400 mb-4">
              By using The Lifecycle Canvas, you agree to the following terms:
            </p>
            <ul className="text-slate-400 space-y-2 list-disc list-inside">
              <li>The service is provided "as is" without warranties of any kind</li>
              <li>You are responsible for maintaining the confidentiality of your data</li>
              <li>We reserve the right to modify or discontinue the service at any time</li>
              <li>You agree not to use the service for any unlawful purposes</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">Privacy Policy</h2>
            <p className="text-slate-400 mb-4">
              Your privacy is important to us. Here's how we handle your information:
            </p>
            <ul className="text-slate-400 space-y-2 list-disc list-inside">
              <li>We collect only the data necessary to provide the service</li>
              <li>Your lifecycle plans are stored securely and are not shared with third parties</li>
              <li>We use cookies for session management and improving user experience</li>
              <li>You may request deletion of your data at any time</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">Cookies</h2>
            <p className="text-slate-400">
              This website uses essential cookies to maintain your session and preferences. By using our service, you consent to the use of these cookies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Contact</h2>
            <p className="text-slate-400">
              For any legal inquiries, please visit{" "}
              <a
                href="https://therockinglobster.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-teal-400 hover:text-teal-300 underline"
              >
                The Rocking Lobster
              </a>
              .
            </p>
          </section>
        </div>
      </section>
    </Layout>
  );
}
